import api from '~/api/api.js'

export interface VinRequestSubmitData {
  name: string
  phone: string
  carBrand: string
  carModel: string
  carYear: string | number
  vin: string
  partsList: string
}

export const VinRequest = {
  submit: (data: VinRequestSubmitData) => {
    const fd = new FormData()
    fd.append('name', data.name)
    fd.append('phone', data.phone)
    fd.append('carBrand', data.carBrand)
    fd.append('carModel', data.carModel)
    fd.append('carYear', String(data.carYear))
    fd.append('vin', data.vin)
    fd.append('partsList', data.partsList)
    return api('/vin-requests/submit', fd, 'POST')
  },

  attach: (hash: string) => {
    const fd = new FormData()
    fd.append('hash', hash)
    return api('/vin-requests/attach', fd, 'POST')
  },

  info: (hash: string) => api('/vin-requests/info', { hash }),

  my: () => api('/vin-requests/my'),
}
